import axios from 'axios';
import {api} from '../../constants/api';
import {errors as E} from 'common/constants/errors';

export const sendPDFDraft = ({shumaId, email}) => {
  return (dispatch) => {
    const data = {
      shumaID: parseInt(shumaId, 10),
      emailAddressTo: email
    };

    return axios.post(api.SEND_PDF_DRAFT, data)
      .then((response) => {
        const {errorCode} = response.data;
        if (errorCode < 0) throw new Error(E.SERVER_ERROR);
      })
  };
};
